import { TextConstants } from "./TextConstants";
import {
  STATUSES,
  DRIVER_STATUSES,
  ORDER_STATUSES,
  ORDER_STATUS,
  DELIVERY_EXECUTION_STATUS,
  DEFAULT_FILTER_CHIP,
  ALL_FILTER_CHIP,
  NON_EDITABLE_STATUSES,
  REFRESHABLE_STATUSES,
  DRIVER_ASSIGNED_SUCCESS_MSG,
  DEFAULT_STATUS_SELECTION,
  PARTIALLY_DELIVERED,
  REPLANNING_CONSIGNMENT_SUCCESS_MSG,
  ADDRESS_MARKED_UNVERIFIED,
  DRIVER_SHARED_CONSTANTS,
  CLUBBED_RESTRICTED_STATUSES,
} from "./SharedConstants/ExpressSharedConstants";

export enum EXPRESS_DELIVERY_TYPE {
  UNASSIGNED = "UNASSIGNED",
  ASSIGNED = "ASSIGNED",
  ON_HOLD = "ON_HOLD",
  DELIVERY_ATTEMPTED = "DELIVERY_ATTEMPTED",
  UNDELIVERED = "UNDELIVERED",
  DELIVERED = "DELIVERED",
}

export enum AddressStatus {
VERIFIED = 'VERIFIED',
UNVERIFIED = 'UNVERIFIED',
PENDING = 'PENDING',
}

export enum FilterChips {
  UNASSIGNED = "UNASSIGNED",
  ON_HOLD = "ON_HOLD",
  ASSIGNED = "ASSIGNED",
  OUT_FOR_DELIVERY = "OUT_FOR_DELIVERY",
  COMPLETED = "COMPLETED",
  ALL = "ALL",
}

export enum ASSIGNEE_TYPE {
  DRIVER = "DRIVER",
  HELPER = "HELPER",
}

const ExpressConstants = {
  EXPRESS_CONSTANTS: {
    CONSIGNMENTS_DATA: {
      TABLE_WRAPPER_DATA: {
        title: "Consignments",
        HeaderData: [
          {
            field: "id",
            headerName: "Id",
            hide: true,
          },
          {
            field: "hubCode",
            headerName: "Hub",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "hub",
              fieldName: "hub",
              fieldFullName: "hub",
              multiple: true,
              key: `autoComplete-hub`,
              label: "Hub Code",
              items: [],
            },
          },
          {
            field: "hubNames",
            headerName: "Hub Name",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "hubName",
              fieldName: "hubName",
              fieldFullName: "hubName",
              multiple: true,
              key: `autoComplete-hubName`,
              label: "Hub Name",
              items: [],
            },
          },
          {
            field: "consignmentId",
            headerName: "Consignment ID",
            width: 195,
          },
          {
            field: "status",
            headerName: "Order Status",
            width: 186,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "status",
              fieldName: "status",
              fieldFullName: "status",
              multiple: true,
              key: `autoComplete-status`,
              label: "Order Status",
              items: [],
            },
          },
          {
            field: "vehicle",
            headerName: "Vehicle",
            width: 100,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "orderVehicleType",
              fieldName: "orderVehicleType",
              fieldFullName: "orderVehicleType",
              multiple: true,
              key: `autoComplete-vehicles`,
              label: "Vehicles",
              items: [],
            },
          },
          {
            field: "promiseTime",
            headerName: "Delivery Promise",
            width: 100,
          },
          {
            field: "deliveryStatus",
            headerName: "Status",
            width: 186,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryStatus",
              fieldName: "deliveryStatus",
              fieldFullName: "deliveryStatus",
              multiple: true,
              key: `autoComplete-deliveryStatus`,
              label: "Hub Name",
              items: [],
            },
          },
          {
            field: "activity",
            headerName: "Activity Type",
            width: 150,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "activity",
              fieldName: "activity",
              fieldFullName: "activity",
              multiple: true,
              key: `autoComplete-activity`,
              label: "activity",
              items: [],
            },
          },
          {
            field: "actions",
            headerName: "Actions",
            width: 100,
            hide: false,
          },
          {
            field: "driverName",
            headerName: "Driver",
            width: 150,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "driverId",
              fieldName: "driverId",
              fieldFullName: "driverId",
              multiple: true,
              key: `autoComplete-driverId`,
              label: "Driver Name",
              items: [],
            },
          },
          {
            field: "supportDriverName",
            headerName: TextConstants.SUPPORT_DRIVER,
            width: 150,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "supportDriverId",
              fieldName: "supportDriverId",
              fieldFullName: "supportDriverId",
              multiple: true,
              key: `autoComplete-supportDriverId`,
              label: TextConstants.SUPPORT_DRIVER,
              items: [],
            },
          },
          {
            field: "deliveryArea",
            headerName: "Customer Area",
            width: 180,
            tooltip: true,
            tooltipDataKey: "address",
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryArea",
              fieldName: "deliveryArea",
              fieldFullName: "deliveryArea",
              multiple: true,
              key: `autoComplete-deliveryArea`,
              label: "Area",
              category: "ExpressArea",
              items: [],
            },
          },
          {
            field: "addressStatus",
            headerName: "Address Status",
            width: 160,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "addressStatus",
              fieldName: "addressStatus",
              fieldFullName:
                "c.deliveryInformation.customerContactInfo.address.status",
              multiple: true,
              key: `autoComplete-addressStatus`,
              label: "Area",
              items: [],
            },
          },
          {
            field: "deliveryZone",
            headerName: "Zone",
            width: 150,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryZone",
              fieldName: "deliveryZone",
              fieldFullName: "c.metadata.deliveryZone",
              multiple: true,
              key: `autoComplete-deliveryZone`,
              label: "Zone",
              items: [],
            },
          },
          {
            field: "deliverySlotTime",
            headerName: "Delivery Time",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldName: "deliverySlotTime",
              multiple: true,
              key: `autoComplete-deliverySlot`,
              label: "Delivery Slot",
              items: [],
              fieldKey: "deliverySlotTime",
            },
          },

          {
            type: "date",
            field: "deliveryDate",
            headerName: "Delivery Date",
            width: 160,
            filter: true,
            filterObj: {
              type: "dateRange",
              fieldKey: "deliveryDate",
              fieldName: "dateRange",
              key: `dateRange-filter`,
              placeholderText: "Delivery Date",
              label: "Delivery Date",
              autoUpdateInput: false,
              autoApply: true,
              showDropdowns: true,
              linkedCalendars: true,
              maxSpan: {
                month: "1",
              },
              locale: {},
            },
          },
          {
            field: "paymentType",
            headerName: "Payment Type",
            width: 160,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "paymentType",
              fieldName: "paymentType",
              fieldFullName: "paymentType",
              multiple: true,
              key: `autoComplete-paymentType`,
              label: "Payment Type",
              items: [],
            },
          },

          {
            field: "orderId",
            headerName: "Order ID",
            width: 150,
          },
          {
            field: "transactionDate",
            headerName: "Order Creation Date",
            width: 170,
          },
          {
            field: "deliveryActualTime",
            headerName: "Delivery Duration(mins)",
            width: 180,
          },
          {
            field: "deliveryExecutionStatus",
            headerName: "Delivery Status",
            width: 180,
            filter: true,
            filterObj: {
              type: "autocomplete",
              fieldKey: "deliveryExecutionStatus",
              fieldName: "deliveryExecutionStatus",
              fieldFullName: "deliveryExecutionStatus",
              multiple: true,
              key: `autoComplete-deliveryExecutionStatus`,
              label: "Delivery Status",
              items: [],
            },
          },
          {
            field: "customerName",
            headerName: "Customer Name",
            width: 150,
          },
          {
            field: "customerEmail",
            headerName: "Customer Email",
            width: 180,
          },
          {
            field: "totalAmount",
            headerName: "Total Order Value",
            width: 140,
          },
          {
            field: "codAmount",
            headerName: "COD Amount",
            width: 130,
          },
          {
            field: "collectedAmount",
            headerName: "Collected Amount",
            width: 160,
          },
          {
            field: "undeliveredReason",
            headerName: "Undelivered Reason",
            width: 160,
          },
        ],
        headerButtons: [
          {
            name: "colsettings",
            displayName: "Column Settings",
            disabled: false,
            childElements: [
              {
                name: "excel",
                displayName: "Export Data",
                disabled: false,
              },
            ],
          },
        ],
        sortModel: {
          field: "deliveryDate",
          direction: "asc",
        },
        loadMore: {
          name: "loadMore",
          disabled: false,
          pageSize: 20,
        },
        defaultFiltersObj: {
          hub: {
            key: "hub",
            value: [],
          },
          hubName: {
            key: "hubNames",
            value: [],
          },
          deliveryArea: {
            key: "deliveryArea",
            value: [],
          },
          addressStatus: {
            key: "addressStatus",
            value: [],
          },
          activity: {
            key: "activity",
            value: [],
          },
          deliveryZone: {
            key: "deliveryZone",
            value: [],
          },
          deliveryStatus: {
            key: "deliveryStatus",
            value: [],
          },
          status: {
            key: "status",
            value: [],
          },
          orderVehicleType: {
            key: "orderVehicleType",
            value: [],
          },
          paymentType: {
            key: "paymentType",
            value: [],
          },
          deliveryExecutionStatus: {
            key: "deliveryExecutionStatus",
            value: [],
          },
          driverId: {
            key: "driverId",
            value: [],
          },
          supportDriverId: {
            key: "supportDriverId",
            value: [],
          },
          deliverySlotTime: {
            key: "deliverySlotTime",
            value: [],
          },
          pageNumber: 0,
          dateRange: {
            key: "dateRange",
            value: {
              startDate: new Date(),
              endDate: new Date(),
            },
          },
        },
        SEARCH_TYPES: [
          {
            name: "Consignment Id",
            value: "consignmentCode",
          },
          {
            name: "Order Id",
            value: "orderCode",
          },
          {
            name: "Customer Name",
            value: "customerName",
          },
          {
            name: "Customer Email",
            value: "customerEmail",
          },
        ],
      },
      TAB_VALUES: {
        ORDER_DETAIL: "Order Detail",
        ORDER_LOG: "Order",
        ORDER_COMMENTS: "Order Comments",
      },
      DELIVERY_STATUS: {
        DELAYED: "DELAYED",
      },
      STATUSES_ALECTO_CRATE: [
        "UNASSIGNED",
        "ON_HOLD",
        "ASSIGNED",
        "READY_TO_DISPATCH",
        "OUT_FOR_DELIVERY",
      ],
      FILTER_CHIPS: [
        {
          code: "UNASSIGNED",
          value: "Unassigned",
        },
        {
          code: "ON_HOLD",
          value: "On Hold",
        },
        {
          code: "ASSIGNED",
          value: "Assigned",
        },
        {
          code: "PICKED_UP",
          value: "Picked Up",
        },
        {
          code: "OUT_FOR_DELIVERY",
          value: "Out For Delivery",
        },
        {
          code: "COMPLETED",
          value: "Completed",
        },
        {
          code: "ALL",
          value: "All",
        },
      ],
      POTENTIAL_DELAY_STATUSES: [FilterChips.UNASSIGNED, FilterChips.ON_HOLD, FilterChips.ASSIGNED, FilterChips.OUT_FOR_DELIVERY],
      COURIER_SWITCH_FILTER_STATUSES: [FilterChips.UNASSIGNED, FilterChips.ON_HOLD],
      PICKED_UP: 'PICKED_UP',
      STATUSES,
      DRIVER_STATUSES,
      ORDER_STATUSES,
      ORDER_STATUS,
      DELIVERY_EXECUTION_STATUS,
      DEFAULT_FILTER_CHIP,
      ALL_FILTER_CHIP,
      NON_EDITABLE_STATUSES,
      REFRESHABLE_STATUSES,
      CLUBBED_RESTRICTED_STATUSES,
      DRIVER_ASSIGNED_SUCCESS_MSG,
      DEFAULT_STATUS_SELECTION,
      PARTIALLY_DELIVERED,
      REPLANNING_CONSIGNMENT_SUCCESS_MSG,
      ADDRESS_MARKED_UNVERIFIED,
    },
    DELIVER_GROUP_STATUS_UNASSIGNED: "UNASSIGNED",
    COURIER_SWITCHING: {
      MAX_VISIBLE_SWITCHING_RESULTS_IDS: 5,
      MAX_SWITCHING_SELECTION_COUNT: 20,
    },
    DRIVER_DETAILS_DISPLAY: [
      { label: TextConstants.DRIVER_NAME, key: "driverName" },
      { label: TextConstants.PHONE_NUMBER, key: "phone" },
      { label: TextConstants.VEHICLE_TYPE, key: "vehicleType" },
      { label: TextConstants.VENDOR, key: "vendor" },
    ],
    DRIVER_TABS: {
      PRIMARY_DRIVER: TextConstants.PRIMARY_DRIVER,
      SUPPORT_DRIVER: TextConstants.SUPPORT_DRIVER,
    },
    ...DRIVER_SHARED_CONSTANTS,
    VALIDTION_ADDITIONAL_COMMENT: {
      REASON: {
        REQUIRED: {
          msg: "Please select the reason",
        },
      },
      COMMENT: {
        REQUIRED: {
          msg: "Additional information is required",
        },
      },
    },
    TEXT_CONSTANTS: {
      DRIVER_LIST_HEADER: {
        DRIVER_NAME: "Driver Name",
        VEHICLE: " Vehicle",
        STATUS: "Status",
        PROXIMITY: "Proximity",
        TO_HUB: "To Hub",
        ORDERS: "Orders",
      },
      SUPPORT_DRIVER_LIST: "Support Driver List",
      DRIVER_LIST: "Drivers List",
    },
  },
};

export default ExpressConstants;
